import ProductItem from './product-item.js'
import ResponsiveImage from '../components/responsive-image.vue'

export default {
  components: {
    ProductItem,
    ResponsiveImage
  },

  props: {
    products: {
      type: Array,
      required: true
    },

    promotionalPrices: {
      type: Array
    }
  },

  data () {
    return {
      isRowTwoVisible: false,
      isRowThreeVisible: false,
      productRows: {
        rowOne: [],
        rowTwo: [],
        rowThree: []
      }
    }
  },

  created () {
    this.products.forEach((product) => {
      const matchedData = this.promotionalPrices.find((price) => product.id === price.id)

      product.promotionalPrice = matchedData.promotional_price * 100 ?? null
    })
  },

  mounted () {
    this._splitRows()
  },

  methods: {
    triggerRowTwo () {
      this.isRowTwoVisible = true
    },
    triggerRowThree () {
      this.isRowThreeVisible = true
    },
    closeAllRows () {
      this.isRowTwoVisible = false
      this.isRowThreeVisible = false
    },
    _splitRows () {
      const rowOneData = []
      const rowTwoData = []
      const rowThreeData = []

      this.products.forEach((product, index) => {
        if (index > 5) {
          rowThreeData.push(product)
        } else if (index < 2) {
          rowOneData.push(product)
        } else {
          rowTwoData.push(product)
        }
      })

      this.productRows.rowOne = rowOneData
      this.productRows.rowTwo = rowTwoData
      this.productRows.rowThree = rowThreeData
    }
  }
}
